import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
var _excluded = ["children", "testId", "view", "position", "icon", "isImportant", "isClosable", "closePosition", "textAlign", "onClose", "closeOnDocumentClick"];
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * <HintCover> используем как обёртку для Hint'a с абсолютным позиционированием,
 * чтобы Hint мог правильно спозиционироваться.
 * Или используем любой блок с position: relative компонента, в котором вызываем Hint
 */

import React, { useRef } from 'react';
import { Button } from '../Button';
import { IconSvg, Svg } from '../IconSvg';
import { useOutsideClick } from '../../hooks/useOutsideClick';
import { helperViewHintList } from './utils';
import { HintContainer, HintInner, Icon, ButtonClose, arrowHorizontalLeft, arrowHorizontalRight, HintBackdrop, HintSkin } from './styles';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var viewHint = ['success-dim', 'success', 'warning', 'error', 'error-dim', 'danger', 'info', 'alert', 'buy', 'sell'];
export var positionHint = ['default', 'top', 'bottom', 'left', 'right', 'bottom-static', 'static', 'absolute'];
export var positionClose = ['top', 'middle'];
var IconHintArrowLeft = function IconHintArrowLeft(props) {
  return _jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 35 48",
    preserveAspectRatio: "none"
  }, props), {}, {
    children: _jsx("path", {
      d: "M35 48H28.7C19.5 48 17 44.5 12.6 39.4L0 24L12.7 8.7C15.2 5.5 16.6 4 18.2 2.8C19.6 1.7 21.2 1 22.9 0.5C24.7 0 26.7 0 30.5 0H35"
    })
  }));
};
var IconHintArrowRight = function IconHintArrowRight(props) {
  return _jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 35 48",
    preserveAspectRatio: "none"
  }, props), {}, {
    children: _jsx("path", {
      d: "M0 48H6.3C15.5 48 18 44.5 22.4 39.4L35 24L22.3 8.7C19.8 5.5 18.4 4 16.8 2.8C15.4 1.7 13.8 1 12.1 0.5C10.3 0 8.3 0 4.5 0H0"
    })
  }));
};
export var Hint = function Hint(props) {
  var children = props.children,
    testId = props.testId,
    _props$view = props.view,
    view = _props$view === void 0 ? 'success' : _props$view,
    _props$position = props.position,
    position = _props$position === void 0 ? 'default' : _props$position,
    icon = props.icon,
    isImportant = props.isImportant,
    isClosable = props.isClosable,
    _props$closePosition = props.closePosition,
    closePosition = _props$closePosition === void 0 ? 'middle' : _props$closePosition,
    _props$textAlign = props.textAlign,
    textAlign = _props$textAlign === void 0 ? 'left' : _props$textAlign,
    onClose = props.onClose,
    closeOnDocumentClick = props.closeOnDocumentClick,
    other = _objectWithoutProperties(props, _excluded);
  var containerRef = useRef(null);
  var _useOutsideClick = useOutsideClick(containerRef, closeOnDocumentClick, onClose),
    _useOutsideClick2 = _slicedToArray(_useOutsideClick, 1),
    isClosed = _useOutsideClick2[0];
  if (isClosed) {
    return null;
  }
  var renderArrow = function renderArrow(color) {
    if (position === 'left' || position === 'right') {
      return _jsxs(_Fragment, {
        children: [position === 'left' && _jsx(IconHintArrowRight, {
          width: 35,
          height: "100%",
          color: color || helperViewHintList[view].backgroundColor,
          css: arrowHorizontalRight
        }), position === 'right' && _jsx(IconHintArrowLeft, {
          width: 35,
          height: "100%",
          color: color || helperViewHintList[view].backgroundColor,
          css: arrowHorizontalLeft
        })]
      });
    }
    return null;
  };
  return _jsxs(HintContainer, _objectSpread(_objectSpread({
    ref: containerRef,
    "data-testid": testId,
    role: "alert",
    position: position,
    isImportant: isImportant
  }, other), {}, {
    children: [position !== 'default' && position !== 'bottom-static' && position !== 'static' && _jsx(HintBackdrop, {
      view: view,
      position: position,
      children: renderArrow('inherit')
    }), _jsxs(HintSkin, {
      view: view,
      position: position,
      isImportant: isImportant,
      children: [renderArrow(), _jsxs(HintInner, {
        position: position,
        isImportant: isImportant,
        textAlign: textAlign,
        children: [icon && _jsx(Icon, {
          children: icon
        }), _jsx("div", {
          children: children
        }), isClosable && _jsx(ButtonClose, {
          closePosition: closePosition,
          children: _jsx(Button, {
            size: "S",
            view: "transparent",
            shape: "circle",
            onClick: onClose,
            children: _jsx(IconSvg, {
              src: "close",
              color: "inherit"
            })
          })
        })]
      })]
    })]
  }));
};
//# sourceMappingURL=index.js.map